import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';
import Spline from '../spline.js';
import AssetCacher, { ASSET_TYPE } from '../assetCacher.js';
import GlobalDefs from '../../../globalDefs.js';

export default class NodeLoadCurve extends Node
{
	constructor(pParent)
	{
		super(pParent);	

		const pAssetProvider = this.getGraph().getAssetProvider();
		const pPathChoices = pAssetProvider.getPathList();

		this.addInput(PARAM_TYPE.DROPDOWN_PATH, 'curveId', pPathChoices[0]?.key, { dropdownOptions: pPathChoices });
		this.addInput(PARAM_TYPE.BOOLEAN, 'center_x', true);
		this.addInput(PARAM_TYPE.BOOLEAN, 'center_y', true);

		this.addOutput(PARAM_TYPE.SPLINE, 'spline');
		this.addOutput(PARAM_TYPE.FLOAT, 'width');
		this.addOutput(PARAM_TYPE.FLOAT, 'height');

		this.lastUsedCurveId = '';

		this.lastBBox = null;

		this.dirtyAfterCurveDataProcessing = true;
	}
	
	getType()
	{
		return 'loadCurve';
	}

	getIsLoading()
	{
		return AssetCacher.getInstance().getIsNodeLoading(this);
	}

	getReferencedAssetIds(resMapOut)
	{
		let assetKey = this.getLastInputResult('curveId');
		if(assetKey && assetKey != GlobalDefs.g_strNoneKey && resMapOut['profileIds'].indexOf(assetKey) < 0)
			resMapOut['profileIds'].push(assetKey);
	}

	processCurveData(jsonCurveData, inputValues)
	{
		// Center on origin by default
		// Ensure we make a copy.
		let pSpline = new Spline({...jsonCurveData});
		if(inputValues['center_x'] || inputValues['center_y'])
		{
			let bbox = pSpline.getBBox();
			let vecCenter = bbox.max.add(bbox.min).scale(0.5);
			if(!inputValues['center_x'])
				vecCenter.x = 0;
			if(!inputValues['center_y'])
				vecCenter.y = 0;
			pSpline.translate(-vecCenter.x, -vecCenter.y);
		}
		pSpline.removeCollinearPoints();

		this.lastBBox = pSpline.getBBox();

		// We need this because it may affect the overall dimensions of the object,
		// resulting in a different bbox
		if(this.dirtyAfterCurveDataProcessing)
		{
			this.dirtyAfterCurveDataProcessing = false;
			this.markDirtyDelayed();
		}
		return pSpline.saveToObject();
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		if(outputName === 'width' || outputName === 'height')
		{
			if(!this.lastBBox)
				return 0;

			if(outputName === 'width')
				return this.lastBBox.max.x - this.lastBBox.min.x;
			else
				return this.lastBBox.max.y - this.lastBBox.min.y;
		}
		

		let strSelectedKey = inputValues['curveId'];
		if(!strSelectedKey || String(strSelectedKey).length === 0)
			return null;

		if(this.lastUsedCurveId != strSelectedKey)
			this.dirtyAfterCurveDataProcessing = true;

		this.lastUsedCurveId = strSelectedKey;

		const assetCacher = AssetCacher.getInstance();
		let pCachedCurve = assetCacher.getCachedAsset(ASSET_TYPE.PATH, strSelectedKey, scene, undefined, this);
		if(pCachedCurve)
			return this.processCurveData(pCachedCurve, inputValues);

		const pAssetProvider = this.getGraph().getAssetProvider();
		const pPathData = pAssetProvider.getPath(strSelectedKey);

		let strFullPath;
		if(pPathData)
			strFullPath = pPathData.file;

		if(!strFullPath || strFullPath == '')
			return null;

		// This is actually a local curve
		if(strFullPath.points)
			return this.processCurveData(strFullPath, inputValues);

		// Fetch it from the link:
		assetCacher.getJSONAsset(this, ASSET_TYPE.PATH, strSelectedKey, 
			() => {	this.getGraph().onStartLoadingAsset(); },
			() => 
			{
				this.markDirty();
				this.getGraph().onFinishLoadingAsset();
			});

		return null;
	}
}
